import { render, staticRenderFns } from "./Tab5.vue?vue&type=template&id=45db4a42&scoped=true&"
import script from "./Tab5.vue?vue&type=script&lang=ts&"
export * from "./Tab5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db4a42",
  null
  
)

export default component.exports